// Vector 2D

function Vector2(x, y) {
  this.x = x || 0;
  this.y = y || 0;
}

// Method to add a vector
Vector2.prototype.add = function(vector) {
  return new Vector2(this.x + vector.x, this.y + vector.y);
};

// Method to subtract a vector
Vector2.prototype.sub = function(vector) {
  return new Vector2(this.x - vector.x, this.y - vector.y);
};

// Method to scale by a ratio
Vector2.prototype.scale = function(ratio) {
  return new Vector2(this.x * ratio, this.y * ratio);
};

// Method to mag the vector
Vector2.prototype.mag = function() {
  return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2));
};

// Method to clone the vector
Vector2.prototype.clone = function() {
  return new Vector2(this.x, this.y);
};

// Method to measure distance to another vector
Vector2.prototype.distanceTo = function(vector) {
  return Math.hypot(vector.x - this.x, vector.y - this.y);
  // var a = this.x - vector.end.x;
  // var b = this.y - vector.end.y;
  // return Math.sqrt(a * a + b * b);
};

// Method to get the raw coordinates
Vector2.prototype.toObject = function() {
  return {
    x: this.x,
    y: this.y
  };
};
